interface IndexProps {
  name: string;
  color?: string;
  width?: Number;
  height?: Number;
  style?: object;
  onClick?: (e: any) => void;
}

export const SvgIcon = (props: IndexProps) => {
  const { name, color, width, height, style, onClick } = props;
  return (
    <svg
      style={{
        width: width + "px",
        height: height + "px",
        position: "relative",
        display: "inline-block",
        verticalAlign: "middle",
        ...style,
      }}
      aria-hidden="true">
      <use onClick={onClick} xlinkHref={"#" + name} fill={color} />
    </svg>
  );
};
